import { Box, Typography } from "@material-ui/core"
import moment from "moment"
import styled from "styled-components"

const StyledBox = styled(Box)``

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  line-height: 26px;
  text-align: right;
  span {
    font-weight: bold;
    font-family: NarkisBlock;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 680px;
  }
`
type GiftCardSummaryTextProps = {
  price: string | number
  amount: number
  startDateTime: Date | string
  endDateTime: Date | string
  chargeAmount: number
}
const GiftCardSummaryText = ({
  price,
  amount,
  startDateTime,
  endDateTime,
  chargeAmount,
}: GiftCardSummaryTextProps) => {
  return (
    <StyledBox>
      {amount > 1 ? (
        <StyledText>
          בחרת לשלוח <span>{amount}</span> גיפטקארדים על סך{" "}
          <span>
            {price.toString().replace(/[₪]/g, "")} {`ש"ח`}
          </span>{" "}
          לכל אחד. הגיפטקארדים הראשונים יחוייבו היום ויישלחו ב-{" "}
          <span>{moment(startDateTime).format("DD.MM.YYYY")}</span> ולאחר מכן
          נחייב עוד <span>{chargeAmount - 1}</span> פעמים עד לתאריך האחרון שקבעת
          ב- <span>{moment(endDateTime).format("DD.MM.YYYY")}</span>
        </StyledText>
      ) : (
        <StyledText>
          בחרת לשלם גיפטקארד על סך{" "}
          <span>
            {price.toString().replace(/[₪]/g, "")} {`ש"ח`}
          </span>
          . הגיפטקארד הראשון יחוייב היום ויישלח ב-{" "}
          <span>{moment(startDateTime).format("DD.MM.YYYY")}</span> ולאחר מכן
          נחייב עוד <span>{chargeAmount - 1}</span> פעמים עד לתאריך האחרון שקבעת
          ב- <span>{moment(endDateTime).format("DD.MM.YYYY")}</span>
        </StyledText>
      )}
    </StyledBox>
  )
}

export default GiftCardSummaryText
